import React from 'react';

function Main() {
    return (
        <div style={{ height: "90vh", width: "100%", backgroundColor: "#fff", borderBottomRightRadius: "20px",
            padding: "10px 15px"
         }}>
                <div style={{ margin: "100px auto 0px auto" }}>
                    <div style={{ textAlign: "center" }}>
                        <img src="/images/herdr-orange-logo-cat-v1.png"
                            style={{ width: "150px", opacity: ".9" }}
                        />    
                    </div>
                    <div style={{ textAlign: "center", marginTop: "20px", fontWeight: "500" }}>
                        Create and load a roadmap to get started...
                    </div>
                </div>
        </div>
    );
}

export default Main;